import type React from "react";
import ClockIcon from "../assets/svgs/common/clock.svg";
// import MiniStats from "./mini-stats.components";
import { Button } from "./ui/button";
import ArrowTopRightIcon from "../assets/svgs/common/arrow-top-right.svg";

import { Link } from "react-router-dom";

import AddImageIcon from "../assets/svgs/common/add-image.svg";

import type { IProposal } from "../types/models/proposals.modals.types";
import { Badge } from "./ui/badge";
import { DateTime } from "luxon";

interface AppProps {
	proposal: IProposal;
}

const ProposalDraftCard: React.FunctionComponent<AppProps> = ({ proposal }) => {
	function getActionPathAndTitle() {
		return {
			path: `proposal/${proposal.id}/campaign-details`,
			title: (
				<Button className="flex items-center gap-1 bg-tertiarybuttonbg px-9 py-6 border border-border rounded-lg w-full font-semibold text-base text-secondarybuttontext tracking-wider">
					<>
						View proposal
						<span className="text-2xl">
							<ArrowTopRightIcon />
						</span>
					</>
				</Button>
			),
		};
	}
	const actionInfo = getActionPathAndTitle();

	return (
		<div className="flex items-center w-full">
			<div className="flex flex-col gap-2 pb-5 border border-border rounded-10 w-full overflow-hidden">
				<div className="relative rounded-b-10 w-full overflow-hidden aspect-video">
					<div
						style={{
							background:
								"linear-gradient(180deg, #131313 0%, rgba(19, 19, 19, 0.64) 50.5%, rgba(19, 19, 19, 0.00) 100%)",
						}}
						className="absolute w-full h-20"
					/>

					<span className="top-3 right-3 absolute flex items-center gap-1 bg-badgebg backdrop-blur-sm px-2 py-2 border border-border rounded-full font-bold text-sm">
						<ClockIcon />
						{DateTime.fromISO(proposal.createdAt.toString()).toRelative()}
					</span>
					<div className="top-0 left-0 absolute flex justify-center items-center bg-opacity-50 border-b border-border rounded-xl w-full h-full">
						<AddImageIcon />
					</div>
				</div>
				<div className="flex flex-col gap-4 px-4">
					<div className="flex flex-col gap-4">
						<div className="flex flex-col gap-2 pt-4">
							<Badge className="flex items-center gap-1 bg-tertiarybuttonbg bg-gradient-to-r from-tertiarybuttonbg to-transparent px-2 py-1 border border-border w-fit">
								{proposal.brand.name}
							</Badge>
							<p className="pb-5 w-80 font-semibold text-xl truncate">
								{proposal.name}
							</p>
						</div>

						<div className="flex pb-3 w-full">
							<div className="flex flex-col flex-1 text-left">
								<span className="pl-1 border-primarybuttonbg border-l-2 font-semibold text-secondary text-sm">
									Created by{" "}
								</span>
								<span className="pl-2 font-bold text-lg text-primary">
									{proposal.createdByUser.name}
								</span>
							</div>

							<div className="flex flex-col flex-1 text-left">
								<span className="pl-1 border-primarybuttonbg border-l-2 font-semibold text-secondary text-sm">
									Post type
								</span>
								<span className="pl-2 font-bold text-lg text-primary capitalize">
									{proposal.socialPostType}
								</span>
							</div>
						</div>
					</div>
					{/* <div className="">
						<MiniStats
							campaign={campaign}
							status={campaign.campaignStatus.status }
							stat1={millify(campaign.metrics?.totalCount || 0)}
							stat2={millify(campaign.metrics?.totalPosts || 0)}
							stat3={
								campaign.budget
									? `${millify(campaign.metrics?.budgetUsed || 0)} of ${millify(campaign.budget)}`
									: "-"
							}
						/>
					</div> */}
					<Link className="w-full" to={actionInfo.path}>
						{actionInfo.title}
					</Link>
				</div>
			</div>
		</div>
	);
};

export default ProposalDraftCard;
